<template>
  <div>
    <div class="row">
      <div class="col">
        <under-input v-model="item.name">
          Name
        </under-input>
      </div>
      <div class="col-2 text-center">
        <under-input v-model.number.lazy="item.maximum" type="number" min="0">
          Maximum
        </under-input>
      </div>      
      <div class="col-2 text-center">
        <under-input v-model.number.lazy="item.current" type="number" min="0" :max="item.maximum">
          Current
        </under-input>
      </div>
      <div class="col-flex">
        <under-select v-model="item.type" :options="options">
          Type
        </under-select>
      </div>
    </div>
    <under-text-area-md v-model="item.description" rows="4">
      Description
    </under-text-area-md>
  </div>
</template>
<script>
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "sections-trackables-default",
  components: {
    UnderInput,
    UnderSelect,
    UnderTextAreaMd
  },
  props: ["section", "item"],
  data() {
    return {
      options: [
        { text: "Number", value: "number" },
        { text: "Checkboxes", value: "checkboxes" }
      ]
    };
  }
};
</script>
